import React from "react";

function ProposalTransactions({proposal}) {
    return (
        <div style={{marginTop: 20}}>
            {proposal.signatures.map((s, id) => (
                <div key={id} style={{display: "flex"}}>
                    <span style={{color: "var(--grey0)"}}>{id + 1}</span>
                    <span style={{marginLeft: 10}}>{s}</span>
                </div>
            ))}
        </div>
    )
}

export default ProposalTransactions;